import { storyblokInit as s } from "./storyblok-js.mjs";
import { RichTextResolver as y, RichTextSchema as C, apiPlugin as d, loadStoryblokBridge as f, registerStoryblokBridge as S, renderRichText as x, storyblokEditable as F, registerStoryblokBridge as A } from "./storyblok-js.mjs";
import { default as B } from "./storyblok-component.mjs";
var e = null,
    t = {},
    r = !1,
    l = null;

var b = function b() {
  return e || console.error("You can't use getStoryblokApi if you're not loading apiPlugin."), e;
},
    c = function c(o) {
  return t = o, t;
},
    i = function i(o) {
  return t[o] ? t[o] : (console.error("Component ".concat(o, " doesn't exist.")), !1);
},
    k = function k() {
  return r;
},
    m = function m() {
  return l;
},
    p = function p() {
  var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _s = s(o),
      n = _s.storyblokApi;

  e = n, t = o.components, r = o.enableFallbackComponent, l = o.customFallbackComponent;
};

export { y as RichTextResolver, C as RichTextSchema, B as StoryblokComponent, d as apiPlugin, i as getComponent, m as getCustomFallbackComponent, k as getEnableFallbackComponent, b as getStoryblokApi, f as loadStoryblokBridge, S as registerStoryblokBridge, x as renderRichText, c as setComponents, F as storyblokEditable, p as storyblokInit, b as useStoryblokApi, A as useStoryblokBridge };